export enum PageLink {
  Home = '/',
  Login = '/login',
  Callback = '/callback',
  ImgLogin = '/img/login',
  NoPermission = '/403',
  ContentReview = '/content-review',
  ContentReviewDetail = '/content-review/detail',
  Report = '/report',
  ReportView = '/report/view',
  ReportJudge = '/report/judge',
  Suggestion = '/suggestion',
  SuggestionCheck = '/suggestion/check',
  UserMng = '/user-mng',
  UserMngDetail = '/user-mng/detail',
  // TODO 添加菜单
  UserPoints = '/user-mng/points/:userId',
  UserCoins = '/user-mng/coins/:userId',
  Exhibition = '/exhibition',
  ExhibitionEditor = '/exhibition/editor',
  ExhibitionComment = '/exhibition/comment',
  PictureFrame = '/picture-frame',
  PictureFrameDetail = '/picture-frame/detail',
  ArtworkVerify = '/artwork-verify',
  ArtworkVerifyDetail = '/artwork-verify/verify-detail',
  ArtistVerify = '/artist-verify',
  ArtistVerifyDetail = '/artist-verify/verify-detail',
  ArtistAbout = '/artist-about',
  ArtistAboutEditor = '/artist-about/editor',
  ActivityMng = '/activity-mng',
  ActivityMngEditor = '/activity-mng/editor',
  ResourcePosition = '/resource-position',
  ResourcePositionDetail = '/resource-position/detail',
  // 资源位素材管理
  ResourceMaterial = '/resource-material',
  ResourceMaterialDetail = '/resource-material/detail',
  ResourceMaterialCreate = '/resource-material/create',
  PointsMall = '/points-mall',
  // TODO 添加菜单
  PointsMallDetail = '/points-mall/detail/:orderId',
  UserRegister = '/user-register',
  TopicMng = '/topic-mng',
  TopicMngEditor = '/topic-mng/editor',
  // 社区管理
  CommunityTopicMng = '/community/topic-mng',
  CommunityTopicSubmissions = '/community/topic-mng/submissions/:id',
  ForbiddenWord = '/community/forbidden-word',
  // 投票活动
  // TODO 添加到菜单
  VoteActivity = '/vote-activity',
  VoteActivityDetail = '/vote-activity/detail/:id',
  VoteActivityEditor = '/vote-activity/editor',
  VoteActivitySubmissions = '/vote-activity/submissions/:id',
  VoteActivityCreate = '/vote-activity/create',
  // 抽奖活动
  LotteryActivity = '/lotto-activity',
  LotteryActivityCreate = '/lotto-activity/create',
  LotteryActivityRecord = '/lotto-activity/record',
  Tools = '/tools',
  ToolsImgUpload = '/tools/img-upload',
  ToolsImageScraperUploader = '/tools/image-scraper-uploader',
  ToolsCrypto = '/tools/crypto',
  // 商品管理
  Products = '/products',
  ProductsCreate = '/products/create',
  ProductsEdit = '/products/edit/:id',
  ProductsDetail = '/products/detail/:id',
  // 订单管理
  Order = '/order',
  Recharge = '/recharge',
  // 版本管理
  VersionMng = '/version-mng',
  // VersionMngIos = '/version-mng?platform=2',
  // VersionMngAndroid = '/version-mng?platform=1',
  VersionMngIos = '/version-mng/ios',
  VersionMngAndroid = '/version-mng/android',
  Improper = '/improper',
  // 推送管理
  PushMng = '/push-mng',
  Recall = '/recall',
  // 上传提示词
  PromptUpload = '/prompt-upload',
  // banner配置
  BannerMng = '/banner',
  // liblib配置
  Liblib = '/liblib',
  // 转绘
  Convert = '/convert',

  // 系统通知配置
  NoticeConfig = '/notice-config',
  // 会员管理
  MemberType = '/member/type',
  MemberBenefit = '/member/benefit',
  MemberSubscription = '/member/subscription',
  MemberSuppId = '/member/suppid',
  NewcomerChallenge = '/newcomer-challenge',
  ActivityRules = '/activity-rules',
  // 文生图风格
  TextToImageStyle = '/text-to-image/style',
  // E15 限时任务管理
  LimitedTaskMng = '/task-mng/limited',
}

export const PageLinkMenuKey: { [key: string]: string } = {
  [PageLink.Home]: PageLink.Home,
  [PageLink.Login]: PageLink.Login,
  [PageLink.Callback]: PageLink.Callback,
  [PageLink.ImgLogin]: PageLink.ImgLogin,
  [PageLink.NoPermission]: PageLink.NoPermission,
  [PageLink.ContentReview]: PageLink.ContentReview,
  [PageLink.ContentReviewDetail]: PageLink.ContentReview,
  [PageLink.Improper]: PageLink.Improper,
  [PageLink.Report]: PageLink.Report,
  [PageLink.ReportView]: PageLink.Report,
  [PageLink.ReportJudge]: PageLink.Report,
  [PageLink.Suggestion]: PageLink.Suggestion,
  [PageLink.SuggestionCheck]: PageLink.Suggestion,
  [PageLink.UserMng]: PageLink.UserMng,
  [PageLink.UserMngDetail]: PageLink.UserMng,
  [PageLink.UserPoints]: PageLink.UserMng,
  [PageLink.UserCoins]: PageLink.UserMng,
  [PageLink.Exhibition]: PageLink.Exhibition,
  [PageLink.ExhibitionEditor]: PageLink.Exhibition,
  [PageLink.PictureFrame]: PageLink.PictureFrame,
  [PageLink.PictureFrameDetail]: PageLink.PictureFrame,
  [PageLink.ArtworkVerify]: PageLink.ArtworkVerify,
  [PageLink.ArtworkVerifyDetail]: PageLink.ArtworkVerify,
  [PageLink.ArtistVerify]: PageLink.ArtistVerify,
  [PageLink.ArtistVerifyDetail]: PageLink.ArtistVerify,
  [PageLink.ArtistAbout]: PageLink.ArtistAbout,
  [PageLink.ArtistAboutEditor]: PageLink.ArtistAbout,
  [PageLink.ActivityMng]: PageLink.ActivityMng,
  [PageLink.ActivityMngEditor]: PageLink.ActivityMng,
  [PageLink.ResourcePosition]: PageLink.ResourcePosition,
  [PageLink.ResourcePositionDetail]: PageLink.ResourcePosition,
  [PageLink.ResourceMaterial]: PageLink.ResourceMaterial,
  [PageLink.ResourceMaterialDetail]: PageLink.ResourceMaterial,
  [PageLink.ResourceMaterialCreate]: PageLink.ResourceMaterial,
  [PageLink.PointsMall]: PageLink.PointsMall,
  [PageLink.PointsMallDetail]: PageLink.PointsMall,
  [PageLink.UserRegister]: PageLink.UserRegister,
  [PageLink.TopicMng]: PageLink.TopicMng,
  [PageLink.TopicMngEditor]: PageLink.TopicMng,
  // 社区管理
  [PageLink.CommunityTopicMng]: PageLink.CommunityTopicMng,
  [PageLink.CommunityTopicSubmissions]: PageLink.CommunityTopicMng,
  [PageLink.ForbiddenWord]: PageLink.ForbiddenWord,
  // 投票活动
  [PageLink.VoteActivity]: PageLink.VoteActivity,
  [PageLink.VoteActivityDetail]: PageLink.VoteActivity,
  [PageLink.VoteActivityEditor]: PageLink.VoteActivity,
  [PageLink.VoteActivityCreate]: PageLink.VoteActivity,
  [PageLink.VoteActivitySubmissions]: PageLink.VoteActivity,
  [PageLink.ToolsImgUpload]: PageLink.ToolsImgUpload,
  [PageLink.ToolsImageScraperUploader]: PageLink.ToolsImageScraperUploader,
  [PageLink.ToolsCrypto]: PageLink.Tools,
  [PageLink.Products]: PageLink.Products,
  [PageLink.ProductsCreate]: PageLink.Products,
  [PageLink.ProductsEdit]: PageLink.Products,
  [PageLink.ProductsDetail]: PageLink.Products,
  [PageLink.Order]: PageLink.Order,
  [PageLink.Recharge]: PageLink.Recharge,
  [PageLink.VersionMng]: PageLink.VersionMng,
  [PageLink.VersionMngIos]: PageLink.VersionMngIos,
  [PageLink.VersionMngAndroid]: PageLink.VersionMngAndroid,
  [PageLink.PushMng]: PageLink.PushMng,
  [PageLink.Recall]: PageLink.Recall,
  // 抽奖活动
  [PageLink.LotteryActivity]: PageLink.LotteryActivity,
  [PageLink.LotteryActivityCreate]: PageLink.LotteryActivity,
  [PageLink.LotteryActivityRecord]: PageLink.LotteryActivity,
  [PageLink.PromptUpload]: PageLink.PromptUpload,
  [PageLink.BannerMng]: PageLink.BannerMng,
  [PageLink.Liblib]: PageLink.Liblib,
  [PageLink.Convert]: PageLink.Convert,
  [PageLink.NoticeConfig]: PageLink.NoticeConfig,
  // 会员管理
  [PageLink.MemberType]: PageLink.MemberType,
  [PageLink.MemberBenefit]: PageLink.MemberBenefit,
  [PageLink.MemberSubscription]: PageLink.MemberSubscription,
  [PageLink.MemberSuppId]: PageLink.MemberSuppId,
  [PageLink.NewcomerChallenge]: PageLink.NewcomerChallenge,
  [`${PageLink.NewcomerChallenge}/detail/:id`]: PageLink.NewcomerChallenge,
  [`${PageLink.NewcomerChallenge}/submissions/:id`]: PageLink.NewcomerChallenge,
  [PageLink.ActivityRules]: PageLink.ActivityRules,
  [`${PageLink.ActivityRules}/detail/:id`]: PageLink.ActivityRules,
  // 文生图风格
  [PageLink.TextToImageStyle]: PageLink.TextToImageStyle,
  // E15 限时任务管理
  [PageLink.LimitedTaskMng]: PageLink.LimitedTaskMng,
};
